module.exports = __webpack_public_path__ + "static/img/6.b594d09.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/5/1/zh/6.png
// module id = gIQm
// module chunks = 0